import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "C:/Apps/allins-web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.map";
import _slicedToArray from "C:/Apps/allins-web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.object.assign";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/****  React Tiny FAB - Deric Cain<deric.cain@gmail.com>  *****/
import React, { useState } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var AB = function AB(a) {
  return React.createElement("button", _extends({
    type: "button"
  }, a, {
    className: "rtf--ab"
  }), a.children);
};

var MB = function MB(a) {
  return React.createElement("button", _extends({
    type: "button",
    className: "rtf--mb"
  }, a), a.children);
};

var defaultPosition = {
  bottom: 24,
  right: 24
},
    Fab = function Fab(_ref) {
  var _ref$event = _ref.event,
      f = _ref$event === void 0 ? "hover" : _ref$event,
      _ref$position = _ref.position,
      g = _ref$position === void 0 ? defaultPosition : _ref$position,
      _ref$alwaysShowTitle = _ref.alwaysShowTitle,
      h = _ref$alwaysShowTitle === void 0 ? !1 : _ref$alwaysShowTitle,
      a = _ref.children,
      b = _ref.icon,
      c = _ref.mainButtonStyles,
      d = _ref.onClick,
      e = _ref.text;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      j = _useState2[0],
      k = _useState2[1],
      l = h || !j,
      m = function m() {
    return k(!0);
  },
      n = function n() {
    return k(!1);
  },
      o = function o(a, b) {
    a.persist(), k(!1), setTimeout(function () {
      b(a);
    }, 1);
  };

  return React.createElement("ul", {
    onMouseEnter: function onMouseEnter() {
      return "hover" === f && m();
    },
    onMouseLeave: function onMouseLeave() {
      return "hover" === f && n();
    },
    className: "rtf ".concat(j ? "open" : "closed"),
    style: g
  }, React.createElement("li", {
    className: "rtf--mb__c"
  }, React.createElement(MB, {
    onClick: function onClick(a) {
      return d ? d(a) : (a.persist(), "click" === f ? j ? n() : m() : null);
    },
    style: c,
    role: "button",
    "aria-label": "Floating menu",
    tabIndex: "0"
  }, b), e && React.createElement("span", {
    className: "".concat("right" in g ? "right" : "", " ").concat(h ? "always-show" : ""),
    "aria-hidden": l
  }, e), React.createElement("ul", null, function () {
    return React.Children.map(a, function (a, b) {
      return a && React.createElement("li", {
        className: "rtf--ab__c ".concat("top" in g ? "top" : "")
      }, React.cloneElement(a, _objectSpread(_objectSpread({
        "data-testid": "action-button-".concat(b),
        "aria-label": a.props.text || "Menu button ".concat(b + 1),
        "aria-hidden": l,
        tabIndex: j ? 0 : -1
      }, a.props), {}, {
        onClick: function onClick(b) {
          return o(b, a.props.onClick);
        }
      })), a.props.text && React.createElement("span", {
        className: "".concat("right" in g ? "right" : "", " ").concat(h ? "always-show" : ""),
        "aria-hidden": l
      }, a.props.text));
    });
  }())));
};

export { AB as Action, Fab, MB };